import Component from "./Component";
import Button from "./common/Button";
import Dashboard from "./layout/Dashboard";
import DashboardContent from "./layout/DashboardContent";
import { Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useSessionStorageStringState } from "store/hooks/stateHooks";

const ProfilerApp = () => {
  const [profileKey, setProfileKey] = useState(null);
  const normalizedKey = (profileKey ?? "").trim();

  const [profile, setProfile] = useSessionStorageStringState("profile", {
    default: null,
  });
  const profilerActive = (profile ?? "") !== "";

  return (
    <div className={"app"}>
      <Dashboard>
        <DashboardContent>
          <Component
            title={"Session Profiler"}
            subtitle={
              "Runs a trace level profiler on services called from this browser tab"
            }
          >
            {profilerActive ? (
              <Typography className={"fade-in-slow"}>
                {"Profiler is running in this tab"}
              </Typography>
            ) : (
              <Stack
                direction={"row"}
                alignItems={"center"}
                gap={1}
                className={"fade-in-slow"}
              >
                <TextField
                  label={"Profile Key"}
                  value={profileKey}
                  onChange={(e) => setProfileKey(e.target.value)}
                  size={"small"}
                  fullWidth
                />
                <Button
                  sx={{ minWidth: "10rem" }}
                  disabled={normalizedKey === ""}
                  onClick={() => setProfile(profileKey)}
                >
                  {"Start Profiler"}
                </Button>
              </Stack>
            )}
          </Component>
        </DashboardContent>
      </Dashboard>
    </div>
  );
};

export default ProfilerApp;
